<!-- eslint-disable vue/multi-word-component-names -->
<script>
// import Vue from "vue";
import AppPageContainer from '@/components/app/PageContainer.vue';
import ClosingModal from '@/components/800/terminehView/close.modal.vue';
import AppWrappedText from '@/components/app/wrapText.vue';
// ------script---------
import TerminehHelper from '@/Helpers/800/termineh.helper.js';
import TerminehMixin from '@/Mixins/800/termineh.mixin.js';
import SharedMixin from '@/Mixins/Shared';
import SharedHelper from '@/Helpers/Shared';
export default {
  title: 'لیست ترمینه مرکز',
  inject: ['load'],
  components: { AppPageContainer, AppWrappedText, ClosingModal },
  mixins: [TerminehHelper, TerminehMixin, SharedMixin, SharedHelper],
  mounted() {
    this.mounteLoding();
  },
  methods: {
    mounte: function () {
      this.getAllActiveTerminehList();
      this.$mainSignalr.bus.$on('Termine', this.getAllActiveTerminehList);
      this.$mainSignalr.bus.$on('DispatchNotification', this.fNotifyOutOfService);
      this.$mobileSignalr.bus.$on('DispatchNotification', this.fNotifyOutOfService);
    },
    getCreationDate: function (date) {
      date = new Date(date);
      return `${date.toLocaleTimeString('fa-IR')}-${date.toLocaleDateString('fa-IR')}`;
    },
    fNotifyOutOfService: function (data) {
      switch (data?.type) {
        case 1:
          this.showTostMessage2(data?.text, 'ambulance107s', {
            timeout: false,
            closeOnClick: false,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
          });
          break;
        case 2:
          this.showTostMessage2(data?.text, '', {
            timeout: false,
            closeOnClick: false,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
          });
          break;
        default:
          break;
      }
      this.onGetAllUserNotificationOnSignal();
    },
  },
  beforeDestroy() {
    this.$mainSignalr.bus.$off('Termine', this.getAllActiveTerminehList);
    this.$mainSignalr.bus.$off('DispatchNotification', this.fNotifyOutOfService);
    this.$mobileSignalr.bus.$off('DispatchNotification', this.fNotifyOutOfService);

    // delete this.$root.$refs.Recent800Calls;
  },
};
</script>
<template>
  <app-page-container title="ترمینه">
    <template v-slot:header>
      <v-col cols="4" class="mr-n11">
        <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense v-model="searchTitle"
          class="mt-3"></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-btn rounded small class="darkColor mt-3" dark icon fab @click="getAllActiveTerminehList">
          <v-icon class="">mdi-refresh mdi-18px</v-icon>
        </v-btn>
      </v-col>
      <v-spacer></v-spacer>
    </template>
    <template v-slot:body>
      <v-row no-gutters class="background-main">
        <v-col cols="12" class="pa-0 ma-0">
          <v-card elevation="0" class="body-card card-width pa-0 ma-0">
            <v-card-text class="pa-0 ma-0">
              <v-row no-gutters>
                <v-col cols="12" class="pa-0">
                  <template>
                    <v-data-table fixed-header id="recent-call-table" :headers="terminehTableHeaders"
                      :items="transformedTerminehList" :search="searchTitle"
                      :items-per-page="transformedTerminehList?.length" height="68dvh" :hide-default-footer="true"
                      multi-sort class="elevation-0">
                      <template v-slot:[`item.status`]="{ item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-if="item?.missionCode?.length > 1" small color="darkColor" v-bind="attrs"
                              v-on="on">
                              mdi-ambulance mdi-18px
                            </v-icon>
                            <v-icon v-else small color="darkColor" v-bind="attrs" v-on="on">
                              mdi-email-outline mdi-18px
                            </v-icon>
                          </template>
                          <span v-if="item?.missionCode?.length > 1">اعزام شده</span>
                          <span v-else>اعزام نشده</span>
                        </v-tooltip>
                      </template>
                      <template v-slot:[`item.creationDate`]="{ item }">
                        <span>
                          {{ getCreationDate(item?.creationDate) }}
                        </span>
                      </template>
                      <template v-slot:[`item.address`]="{ item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <app-wrapped-text :text="item?.address ?? ''" :line="1" v-bind="attrs" v-on="on" />
                          </template>
                          <span>{{ item.address }}</span>
                        </v-tooltip>
                      </template>
                      <template v-slot:[`item.phoneNumber`]="{ item }">
                        <span>
                          {{ setTitles([item?.callerId, item?.otherPhoneNumber], 2, '-') }}
                        </span>
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-row>
                          <v-col>
                            <v-tooltip top>
                              <template v-slot:activator="{ attrs, on }">
                                <v-btn dark icon rounded small v-bind="attrs" v-on="on"
                                  @click="openClosingTerminehModal(item?.id)">
                                  <v-icon dark color="iconColor">mdi-close mdi-18px</v-icon>
                                </v-btn>
                              </template>
                              <span>حذف</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </template>
                      <template v-slot:no-data>
                        <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                      </template>
                    </v-data-table>
                  </template>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template v-slot:append>
      <closing-modal v-if="isClosingTerminehModalOpen" :mission-id="missionId" @close-modal="closeClosingTerminehModal"
        @on-success="getAllActiveTerminehList" />
    </template>
  </app-page-container>
</template>
